import { Component, Input, OnInit } from '@angular/core';
import { ITotalLoopByShiftCards } from '../../../interfaces/report-loop-by-operator';
import { LanguageService } from 'projects/common/src/app/services/parameters';

@Component({
  selector: 'app-transfer-by-shift-cards',
  templateUrl: './transfer-by-shift-cards.component.html',
  styleUrls: ['./transfer-by-shift-cards.component.scss'],
})
export class TransferByShiftCardsComponent implements OnInit {
  @Input() public transferByShiftList: ITotalLoopByShiftCards[];
  @Input() public isTruck: boolean;

  public typeProduction: string;

  constructor(public _languaggeService: LanguageService) {}

  ngOnInit(): void {
    this.typeProduction = this.isTruck ? this._languaggeService.message('loops') : this._languaggeService.message('shelves');
  }
}
